import { baseRoute } from '@pages/layout-page'
import { createRoute } from '@tanstack/react-router'
import { MainPageLayout } from './main-page-layout'
import { MainPageLayoutLoader } from './main-page-layout.loader'

export const mainLayout = createRoute({
  getParentRoute: () => baseRoute,
  id: 'layout',
  component: MainPageLayout,
  loader: MainPageLayoutLoader
})
